import type { IconData } from '@stacksjs/iconify-core'

export const chevronSquareUpRightF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 9v5a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2zM4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronSquareUpRightF
